// extracted by mini-css-extract-plugin
module.exports = {"Share":"ShareDialog_Share__C0x-O","Row":"ShareDialog_Row__1dgcN","InputWrapper":"ShareDialog_InputWrapper__2ui7g","ButtonScreenshot":"ShareDialog_ButtonScreenshot__35thG"};